'use strict'

import { request } from '../../plugins/http'

export default async (companyId, userId) => {
    return await request.get('/aviso',{params:{companyId, userId}})
}